import { useParams } from 'react-router-dom';
import { OffertePagina } from '@/features/offertes/OffertePagina';

/* /crm/quotes/:quoteId. De pagina zelf staat in src/features/offertes (ADR 0018); de
   route in App.tsx blijft deze component (V1-lock). */

const CRMQuoteDetail = () => {
  const { quoteId } = useParams<{ quoteId: string }>();
  return <OffertePagina key={quoteId} quoteId={quoteId!} />;
};

export default CRMQuoteDetail;
